import React from "react";
import { Link } from "react-router-dom";
import { Twitter } from "lucide-react";

function MediaCryptoLogo() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" fill="#facc15"/>
      <polyline points="4,22 10,12 16,18 22,8 28,14" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <circle cx="28" cy="14" r="2" fill="black"/>
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="border-t border-[var(--border-soft)] bg-[var(--bg-panel)] mt-24" data-testid="main-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <MediaCryptoLogo />
            <span className="font-display font-bold text-xl text-[var(--text-primary)]">
              Media<span className="text-yellow-400">Crypto</span>
            </span>
          </div>
          <p className="text-sm text-[var(--text-secondary)] leading-relaxed">
            Real-time crypto intelligence and a high-signal community.
          </p>
          <p className="text-xs text-[var(--text-tertiary)] mt-4 leading-relaxed">
            MediaCrypto is an independent crypto media publication. Content is for informational purposes only and does not constitute financial advice.
          </p>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[var(--text-tertiary)] mb-4">Sections</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/news">News</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/coins">Coins</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/categories">Categories</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/community">Community</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/about">About</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/contact">Contact</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[var(--text-tertiary)] mb-4">Markets</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/categories/bitcoin">Bitcoin</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/categories/ethereum">Ethereum</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/categories/altcoins">Altcoins</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/categories/defi">DeFi</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/categories/market-analysis">Market Analysis</Link></li>
            <li><Link className="text-[var(--text-secondary)] hover:text-yellow-400 transition" to="/coins">Live Prices</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[var(--text-tertiary)] mb-4">Connect</h4>
          <div className="flex items-center gap-3 mb-6">
            <a
              href="https://twitter.com/MediaCryptoAI"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 border border-[var(--border-soft)] flex items-center justify-center hover:border-yellow-400 hover:text-yellow-400 transition text-[var(--text-tertiary)]"
            >
              <Twitter className="w-4 h-4" />
            </a>
          </div>
          <div className="space-y-2">
            <p className="text-xs font-mono text-[var(--text-tertiary)] uppercase tracking-widest">Email</p>
            <a
              href="mailto:contact@mediacrypto.ai"
              className="text-sm text-[var(--text-secondary)] hover:text-yellow-400 transition"
            >
              contact@mediacrypto.ai
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[var(--border-soft)] py-6">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row justify-between items-center gap-3 text-xs font-mono text-[var(--text-tertiary)]">
          <span>© {new Date().getFullYear()} MediaCrypto. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-[var(--text-secondary)] transition">About</Link>
            <Link to="/contact" className="hover:text-[var(--text-secondary)] transition">Contact</Link>
            <Link to="/privacy" className="hover:text-[var(--text-secondary)] transition">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}